export default {
  kameraplaner: {
    intro: {
      badge: 'Interaktivni alat za planiranje – besplatno i neobvezujuće',
      title: 'Planirajte svoj sustav kamera unaprijed',
      lead:
        'Pomoću SSG planera kamera možete crtati prostorije ili površine, označiti vrata, prozore i važne zone nadzora te testirati moguće položaje kamera. Dobivate prvu vizualnu procjenu koju zatim može stručno provjeriti SSG Signaltechnik.',
      noReg: 'Bez registracije',
      localSave: 'Pohranjeno lokalno u pregledniku',
      noBinding: 'Bez obvezujućeg broja kamera',
      quickTitle: 'Pokreni brzu provjeru',
      quickDesc:
        'U pet kratkih koraka odgovorite na pitanja o svom objektu, željenim zonama nadzora i funkcijama. Odmah dobivate jasan sažetak.',
      quickList: { '0': 'Vrsta objekta i zone koje treba nadzirati', '1': 'Željene funkcije i podaci o objektu', '2': 'Sažeti rezultat i izravno poslati' },
      quickCta: 'Pokreni brzu provjeru',
      plannerTitle: 'Samostalno isplanirajte tlocrt',
      plannerDesc:
        'Crtajte prostorije i zidove, postavljajte vrata, prozore, prepreke i kamere – s stošcima vidljivosti, analizom pokrivenosti i automatskim prijedlozima položaja.',
      plannerList: { '0': 'Površina za crtanje s mrežom i mjerilom u metrima', '1': 'Stošci vidljivosti, ciljevi nadzora i privatne zone', '2': 'Prijenos tlocrta, procjena i ispis' },
      plannerCta: 'Samostalno isplanirajte tlocrt',
      savedTitle: 'Postoji spremljeni plan',
      savedDesc: 'Automatski je pohranjen lokalno i može se nastaviti.',
      resume: 'Nastavi zadnji plan',
    },
    quick: {
      steps: { '0': 'Vrsta objekta', '1': 'Zone', '2': 'Funkcije', '3': 'Podaci o objektu', '4': 'Rezultat' },
      back: 'Natrag na pregled',
      title: 'Brza provjera',
      subtitle: 'Pet kratkih koraka – nakon toga dobivate jasan sažetak svoje predplaniranja.',
      stepOf: 'Korak {{current}} od {{total}}',
      objectQuestion: 'Koja vrsta objekta vam odgovara?',
      chooseOne: 'Molimo odaberite opciju.',
      areasQuestion: 'Koje zone treba nadzirati?',
      multiSelect: 'Moguć višestruki odabir.',
      featuresTitle: 'Željene funkcije',
      dataTitle: 'Podaci o objektu',
      dataOptional: 'Svi podaci su neobavezni i mogu se preskočiti.',
      areaSize: 'Približna ukupna površina (m²)',
      roomCount: 'Broj prostorija ili zona',
      inOut: 'Unutarnji, vanjski prostor ili oboje?',
      inside: 'Unutarnji',
      outside: 'Vanjski',
      both: 'Oboje',
      maxDistance: 'Procijenjena najveća udaljenost nadzora',
      pleaseSelect: 'Molimo odaberite',
      distanceUpTo5: 'Do 5 metara',
      distance5to10: '5 do 10 metara',
      distance10to20: '10 do 20 metara',
      distanceOver20: 'Preko 20 metara',
      internet: 'Je li dostupna internetska veza?',
      network: 'Je li dostupno mrežno ožičenje?',
      power: 'Struja na mjestu montaže?',
      yes: 'Da',
      no: 'Ne',
      unknown: 'Nepoznato',
      recordingDuration: 'Željeno trajanje snimanja',
      installType: 'Novi sustav ili postojeći sustav?',
      newSystem: 'Novi sustav',
      existingSystem: 'Postojeći sustav',
      existingManufacturer: 'Proizvođač i model postojećeg sustava (ako je poznat)',
      requirements: 'Posebni zahtjevi',
      requirementsPlaceholder: 'Na primjer posebni svjetlosni uvjeti, zaštita spomenika, posebni uvjeti...',
      chars: '{{current}}/500 znakova',
      ssgCarePre: 'Dodatno me zanima',
      ssgCarePost: '– održavanje i osobna briga o sustavu.',
      overviewTitle: 'Vaše predplaniranje na prvi pogled',
      amberNote:
        'Na temelju vaših podataka može odgovarati više položaja ili vrsta kamera. Za pouzdanu preporuku treba provjeriti kutove gledanja, visinu montaže, osvjetljenje i postojeće prepreke.',
      planFloorplan: 'Dodatno isplaniraj tlocrt',
      sendToSsg: 'Pošalji podatke SSG-u',
      editResult: 'Uredi rezultat',
      backBtn: 'Natrag',
      next: 'Dalje',
      summary: {
        objectType: 'Vrsta objekta',
        areas: 'Zone nadzora',
        features: 'Željene funkcije',
        areaSize: 'Približna ukupna površina',
        roomCount: 'Prostorije / zone',
        inOut: 'Područje',
        maxDistance: 'Najveća udaljenost nadzora',
        internet: 'Internetska veza',
        network: 'Mrežno ožičenje',
        power: 'Struja na mjestu montaže',
        recordingDuration: 'Trajanje snimanja',
        installType: 'Sustav',
        existingSystem: 'Postojeći sustav',
        requirements: 'Posebni zahtjevi',
        ssgCare: 'SSG Care briga',
      },
      values: {
        notSpecified: 'Nije navedeno',
        inside: 'Unutarnji',
        outside: 'Vanjski',
        inOut: 'Unutarnji i vanjski',
        present: 'Dostupno',
        notPresent: 'Nije dostupno',
        unknown: 'Nepoznato',
        unclear: 'još nejasno',
        newSystem: 'Novi sustav',
        existing: 'Postojeći sustav',
        desired: 'Željeno',
      },
    },
    topbar: {
      projectName: 'Naziv projekta',
      undo: 'Poništi',
      undoTip: 'Poništi (Ctrl+Z)',
      redo: 'Ponovi',
      redoTip: 'Ponovi (Ctrl+Y)',
      save: 'Privremeno spremi',
      saved: 'Spremljeno',
      saveTip: 'Privremeno spremi',
      reset: 'Poništi postavke',
      resetTip: 'Poništi planer',
      help: 'Pomoć',
      helpTip: 'Ponovno otvori uvod',
      evaluate: 'Ocijeni plan',
      evaluateTip: 'Ocijeni plan',
    },
    tools: {
      select: { label: 'Odaberi', hint: 'Pomiči, mijenjaj veličinu, rotiraj elemente. Povlačenje prazne površine = pomicanje.' },
      erase: { label: 'Izbriši', hint: 'Izbriši element klikom.' },
      room: { label: 'Pravokutna prostorija', hint: 'Nacrtaj prostoriju ili površinu povlačenjem – dimenzije se prikazuju uživo.' },
      polygon: { label: 'Slobodna površina', hint: 'Nacrtaj slobodnu površinu slobodnom rukom: drži tipku i povuci oblik.' },
      wall: { label: 'Zid', hint: 'Nacrtaj zid povlačenjem – ograničava linije vidljivosti.' },
      door: { label: 'Vrata', hint: 'Postavi vrata na zid – zatim izravno pomakni ili rotiraj.' },
      window: { label: 'Prozor', hint: 'Postavi prozor na zid – zatim izravno pomakni ili rotiraj.' },
      obstacle: { label: 'Prepreka', hint: 'Nacrtaj stup, policu, pregradu ili blok namještaja.' },
      watch: { label: 'Cilj nadzora', hint: 'Označi važno područje koje treba zabilježiti.' },
      privacy: { label: 'Privatna zona', hint: 'Označi područje koje se ne smije zabilježiti.' },
      camera: { label: 'Kamera', hint: 'Postavi kameru klikom. Desno se otvara padajući izbornik modela – odgovarajući model je već preporučen.' },
      text: { label: 'Tekst', hint: 'Dodaj nazive prostorija ili oznake.' },
    },
    editor: {
      tools: 'Alati',
      autoSuggest: 'Automatski prijedlozi',
      analysis: 'Analiza pokrivenosti',
      properties: 'Svojstva',
      backToIntro: 'Natrag na pregled planera kamera',
      resetTitle: 'Poništiti planer?',
      resetText:
        'Svi nacrtani elementi, kamere i učitani tlocrt bit će trajno izbrisani. Spremljeni plan bit će uklonjen.',
      cancel: 'Odustani',
      confirmReset: 'Da, poništi',
      close: 'Zatvori',
      openTools: 'Otvori alate',
      openAnalysis: 'Otvori analizu',
      snap: 'Uključi/isključi prianjanje na mrežu',
      zoomIn: 'Povećaj',
      zoomOut: 'Smanji',
      fit: 'Centriraj tlocrt',
      closeHints: 'Zatvori napomene',
    },
    canvas: {
      areaLabel: 'Površina za crtanje tlocrta',
      calibHint: 'Molimo postavite udaljenost za skaliranje',
      locked: 'zaključano',
      scale: 'Mjerilo: pribl. {{px}} px/m · Mreža {{step}} m',
      calibNotice: 'Kliknite dvije točke na tlocrtu čiju udaljenost znate.',
    },
    props: {
      edit: 'Uredi svojstva',
      delete: 'Izbriši',
      cameraModel: 'Model kamere (stvarni uređaj)',
      nameNumber: 'Naziv / broj',
      cameraCategory: 'Kategorija kamere',
      modelAssigned: 'Model „{{series}}“ je dodijeljen.',
      planningValues: 'Ovo su planske vrijednosti – nisu tehnički podaci stvarnog proizvoda.',
      visibility: 'Vidljivost',
      recognition: 'Prepoznavanje',
      detail: 'Detalj',
      rotation: 'Orijentacija (°)',
      fov: 'Kut gledanja (°)',
      range: 'Domet (m)',
      posX: 'Položaj X (m)',
      posY: 'Položaj Y (m)',
      mountHeight: 'Visina montaže (m)',
      indoor: 'Unutarnji',
      outdoor: 'Vanjski',
      usage: 'Područje primjene',
      dayNight: 'Dan / noć',
      target: 'Željeni cilj nadzora',
      noneAssigned: 'Ništa nije dodijeljeno',
      targetArea: 'Ciljno područje',
      remark: 'Napomena',
      remarkPlaceholder: 'npr. napomene o montaži ili okolini...',
      coneNote: 'Stožac vidljivosti je planski prikaz. Stvarna kvaliteta slike ovisi o modelu, objektivu, udaljenosti, visini montaže, svjetlu i preprekama na mjestu.',
      roomLabel: 'Oznaka prostorije',
      length: 'Duljina (m)',
      width: 'Širina (m)',
      area: 'Površina: pribl. {{area}} m²',
      designation: 'Oznaka',
      points: '{{count}} točaka – točke pomičite izravno na površini za crtanje.',
      wallThickness: 'Debljina zida (m)',
      wallLength: 'Duljina: pribl. {{length}} m',
      wallNote: 'Masivno ucrtani zidovi ograničavaju linije vidljivosti u planeru.',
      obstacleKind: 'Vrsta prepreke',
      shape: 'Oblik',
      rect: 'Pravokutnik',
      circle: 'Krug',
      caption: 'Oznaka',
      diameter: 'Promjer (m)',
      depth: 'Dubina (m)',
      goalKind: 'Vrsta cilja',
      priority: 'Prioritet',
      goal: 'Željeni cilj',
      coverageNote: 'Pokrivenost se ocjenjuje bojom (zeleno / žuto / crveno). Za ciljeve s detaljima vrijede stroži zahtjevi.',
      zoneKind: 'Vrsta zone',
      privacyNote: 'Ako stožac vidljivosti preklapa ovu zonu, u analizi se pojavljuje upozorenje.',
      textContent: 'Sadržaj teksta',
      duplicate: 'Dupliciraj',
      deleteElement: 'Izbriši element',
      projectData: 'Podaci o projektu',
      noElement: 'Nijedan element nije odabran',
      projectName: 'Naziv projekta',
      objectType: 'Vrsta objekta',
      objectTypePlaceholder: 'npr. obiteljska kuća',
      projectDescription: 'Opis projekta',
      projectDescriptionPlaceholder: 'Posebnosti, želje ili okvirni uvjeti...',
      maxChars: 'Najviše 500 znakova',
      cameraForNew: 'Model kamere za nove kamere',
      cameraForNewDesc: 'Dolje odaberite željeni Safire model – padajući izbornik otvara se automatski. Nove kamere postavljaju se s ovim postavkama.',
      recommendedFor: 'Preporučeno za vašu površinu:',
      orGeneric: 'ili generička kategorija',
      tips: 'Savjeti',
      tip1: 'Povlačenje praznog prostora alatom za odabir = pomicanje površine. Kotačić miša = zum.',
      tip2: 'Ctrl+Z = poništi, Ctrl+Y = ponovi, Del = izbriši element.',
      tip3: 'Prianjanje na mrežu može se uključiti/isključiti u opcijama prikaza.',
      suggestPositions: 'Automatski predloži položaje kamera',
      doorSwing: 'Smjer otvaranja',
      left: 'Lijevo',
      right: 'Desno',
      none: 'Nijedno',
      attached: 'Postavljeno na zid – povucite uz zid za pomicanje. Rotacijom se element oslobađa.',
      detached: 'Postavljeno samostalno – slobodno pomičite i rotirajte.',
      doorNote: 'Materijal, ostakljenje i stanje otvaranja moraju se provjeriti na mjestu.',
    },
    result: {
      edit: 'Uredi plan',
      print: 'Ispiši sažetak',
      savePdf: 'Spremi kao PDF',
      send: 'Pošalji plan SSG-u',
      eyebrow: 'Procjena',
      title: 'Vaše predplaniranje na prvi pogled',
      disclaimer:
        'Ova procjena je neobvezujuće predplaniranje. Konačna preporuka daje se tek nakon provjere lokalnih uvjeta i odabira konkretne tehnike kamera.',
      project: 'Projekt',
      objectType: 'Vrsta objekta:',
      uploadPresent: 'Prijenos tlocrta dostupan:',
      scaled: 'skalirano',
      refDistance: 'm referentne udaljenosti',
      notScaled: 'još nije skalirano',
      createdAt: 'Izrađeno',
      floorplan: 'Nacrtani tlocrt',
      noElements: 'Još nema elemenata u tlocrtu.',
      stats: { rooms: 'Prostorije i površine', walls: 'Zidovi', doors: 'Vrata', windows: 'Prozori', obstacles: 'Prepreke', cameras: 'Kamere', zones: 'Ciljna područja', privacy: 'Privatne zone' },
      zonesTitle: 'Ciljevi nadzora i prioriteti',
      noZones: 'Nema označenih ciljeva nadzora.',
      priorityLabel: 'Prioritet',
      goalLabel: 'Cilj',
      goalOverview: 'Pregled',
      goalDetail: 'Detalj',
      goalObservation: 'Promatranje',
      coverage: 'geometrijska pokrivenost',
      camerasTitle: 'Položaji i vrste kamera',
      noCameras: 'Još nema postavljenih kamera.',
      modelLabel: 'Model',
      fovLabel: 'Kut gledanja',
      visibilityLabel: 'Vidljivost pribl.',
      recognitionLabel: 'Prepoznavanje pribl.',
      detailLabel: 'Detalj pribl.',
      positionLabel: 'Položaj',
      rotationLabel: 'Orijentacija',
      rangeLabel: 'Domet pribl.',
      mountLabel: 'Visina montaže',
      indoor: 'Unutarnji',
      outdoor: 'Vanjski',
      day: 'Dan',
      night: 'Noć',
      dayNight: 'Dan i noć',
      target: 'Cilj',
      assigned: 'Dodijeljeno',
      modelNote:
        'Odabrani Safire modeli temelje se na vrijednostima iz tehničkog lista; vidljivost/prepoznavanje/detalj su izračunate planske vrijednosti (EN 62676-4). Bez modela vrijednosti su generičke – nisu tehnički podaci stvarnog proizvoda.',
      blindTitle: 'Mogući mrtvi kutovi i otvorene točke',
      uncovered: 'Područja nedovoljno pokrivena:',
      privacyOverlaps: 'Preklapanja s privatnim zonama:',
      checkPrivacy: 'Provjerite položaj, orijentaciju ili maskiranje.',
      missingTitle: 'Nedostaju važni podaci',
      quickTitle: 'Željene funkcije i podaci o objektu',
      areasLabel: 'Zone:',
      featuresLabel: 'Funkcije:',
      areaLabel: 'Površina:',
      recordingLabel: 'Snimanje:',
      internetLabel: 'Internet:',
      powerLabel: 'Struja:',
      careInterest: 'Zanimanje za SSG Care brigu',
      finalNote: 'Plan će stručno provjeriti SSG Signaltechnik. Visina montaže, osvjetljenje, kutovi i uvjeti na mjestu odlučuju o konačnoj izvedbi.',
      sendBottom: 'Pošalji plan SSG Signaltechniku',
      consult: 'Zatraži osobno savjetovanje',
      good: 'Dobro pokriveno',
      partial: 'Djelomično pokriveno',
      insufficient: 'Nedovoljno',
    },
    send: {
      back: 'Natrag',
      title: 'Pošalji plan SSG Signaltechniku',
      lead:
        'Vaši podaci planiranja (tlocrt, kamere, kutovi gledanja, ciljevi nadzora, privatne zone i rezultat analize) prenose se zajedno s vašim kontakt podacima. Kontakt podaci potrebni su tek sada – sam plan ostaje lokalno na vašem uređaju.',
      dataTitle: 'Preneseni podaci planiranja',
      floorplan: 'Tlocrt',
      rooms: 'Prostorije/površine',
      walls: 'Zidovi',
      doors: 'Vrata',
      windows: 'Prozori',
      obstacles: 'Prepreke',
      cameras: 'Kamere',
      none: 'nijedna',
      zones: 'Ciljevi nadzora',
      privacy: 'Privatne zone',
      analysis: 'Analiza',
      good: 'dobro',
      partial: 'djelomično',
      insufficient: 'nedovoljno pokriveno',
      upload: 'Prijenos tlocrta',
      scaled: 'skalirano',
      notScaled: 'nije skalirano',
      customerType: 'Privatni ili poslovni kupac *',
      privateCustomer: 'Privatni kupac',
      businessCustomer: 'Poslovni kupac',
      name: 'Ime i prezime *',
      company: 'Tvrtka (neobavezno)',
      phone: 'Broj telefona',
      email: 'Adresa e-pošte *',
      projectAddress: 'Adresa projekta',
      projectAddressPlaceholder: 'Ulica, poštanski broj, grad',
      contactPref: 'Preferirani način kontakta',
      any: 'Svejedno',
      byPhone: 'Telefon',
      byEmail: 'E-pošta',
      callbackTime: 'Preferirano vrijeme povratnog poziva',
      noCallback: 'Ne želim povratni poziv',
      morning: 'Prijepodne',
      afternoon: 'Poslijepodne',
      evening: 'Navečer',
      systemStatus: 'Novi ili postojeći sustav',
      newSystem: 'Novi sustav',
      existingSystem: 'Postojeći sustav',
      unsure: 'Još nisam siguran',
      existingManufacturer: 'Proizvođač postojećeg sustava (ako je poznat)',
      existingManufacturerPlaceholder: 'npr. Hikvision, Safire...',
      careInterest: 'Zanimanje za SSG Care',
      careYes: 'Da, molim informirajte me',
      careNo: 'Ne',
      careLater: 'Odlučit ću kasnije',
      message: 'Dodatna poruka',
      messagePlaceholder: 'Dodaci vašem planu...',
      fileUpload: 'Tlocrt / fotografije (neobavezno)',
      fileNote: 'Napomena: prijenosi datoteka tretiraju se kao „Uncollectable“ – podaci planiranja prenose se kao tekst.',
      privacyConsent:
        'Pročitao/la sam izjavu o zaštiti podataka i pristajem na obradu svojih podataka radi obrade ovog upita. Podaci planiranja koriste se isključivo za obradu. *',
      privacyLink: 'Izjava o zaštiti podataka',
      error: 'Došlo je do pogreške. Molimo pokušajte ponovno kasnije.',
      networkError: 'Mrežna pogreška. Provjerite vezu i pokušajte ponovno.',
      successTitle: 'Hvala vam na vašem planu.',
      successText: 'SSG Signaltechnik će provjeriti vaše podatke i osobno vas kontaktirati.',
      sending: 'Slanje...',
      submit: 'Pošalji plan SSG-u',
      backToResult: 'Natrag na procjenu',
    },
    tour: {
      stepOf: 'Korak {{current}} od {{total}}',
      skip: 'Preskoči',
      back: 'Natrag',
      next: 'Dalje',
      finish: 'Krenimo',
      dialogLabel: 'Uvod u planer kamera',
      steps: {
        '0': { title: 'Dobrodošli u SSG planer kamera', text: 'Nacrtajte svoju prostoriju ili učitajte tlocrt.' },
        '1': { title: 'Označite područja', text: 'Označite vrata, prozore i važna područja.' },
        '2': { title: 'Postavite kamere', text: 'Postavite kamere ili prepustite prijedlog položaja.' },
        '3': { title: 'Provjerite vidna polja', text: 'Provjerite vidna polja i moguće mrtve kutove.' },
        '4': { title: 'Pošaljite plan', text: 'Pošaljite predplaniranje SSG Signaltechniku.' },
      },
    },
    analysis: {
      title: 'Analiza pokrivenosti',
      suggest: 'Predloži položaje',
      suggestTip: 'Predloži položaje kamera',
      cameras: 'Kamere',
      zones: 'Ciljna područja',
      good: 'Dobro pokriveno',
      partial: 'Djelomično',
      notCovered: 'Nije pokriveno',
      privacyConflict: 'Sukob privatne zone',
      areaCoverage: 'Geometrijska pokrivenost površine',
      areaNote: 'Geometrijski prikazana pokrivenost – nema iskaza o stvarnoj kvaliteti slike ili prepoznavanja.',
      legend: 'Legenda',
      legendFov: 'Vidno polje kamere',
      legendDetail: 'Oštro prepoznavanje detalja (isprekidano)',
      legendGood: 'Cilj dobro pokriven',
      legendPartial: 'Cilj djelomično pokriven',
      legendBad: 'Cilj nedovoljno',
      legendPrivacy: 'Privatna zona / isključeno',
      note: 'Procjena bojama je geometrijska orijentacija. Širok kut gledanja ne znači automatski dovoljno prepoznavanje detalja – moraju se provjeriti udaljenost, razlučivost i visina montaže.',
    },
    upload: {
      title: 'Učitaj tlocrt',
      desc: 'Neobavezno: učitajte postojeći tlocrt (JPG, PNG ili WebP) kao pozadinu. Zatim označite poznatu udaljenost i unesite njezinu duljinu kako bi planer pravilno skalirao.',
      choose: 'Odaberi tlocrt',
      chooseOther: 'Odaberi drugu sliku',
      remove: 'Ukloni',
      calibPrompt: 'Sada kliknite točku A i točku B na tlocrtu na površini za crtanje.',
      startCalib: 'Pokreni skaliranje',
      scaled: 'Skalirano: {{cm}} cm po pikselu · Udaljenost {{m}} m',
      lengthPlaceholder: 'Duljina u metrima',
      apply: 'Primijeni',
      opacity: 'Prozirnost {{pct}} %',
      lock: 'Zaključaj pozadinu (sprječava slučajno pomicanje)',
      moveHint: 'Za pomicanje: povucite prazno mjesto na slici alatom za odabir (ako nije zaključano).',
      privacyNote: 'Tlocrti i fotografije objekta mogu sadržavati osjetljive informacije. Učitajte samo datoteke potrebne za obradu vašeg upita.',
      onlyImages: 'Molimo odaberite samo slike JPG, PNG ili WebP.',
      tooLarge: 'Datoteka je prevelika. Molimo odaberite sliku manju od 8 MB.',
      readError: 'Datoteka se nije mogla pročitati.',
      validLength: 'Molimo unesite valjanu duljinu u metrima.',
      tooClose: 'Označene točke su preblizu jedna drugoj.',
    },
    picker: {
      generic: 'Odaberi generičku kategoriju',
      genericOption: 'Generička kategorija (bez modela)',
      recommended: 'Preporučeno',
      recommendation: 'Preporuka za vašu površinu',
      fovLabel: 'Kut gledanja',
      detailFrom: 'Detalj od pribl. {{detail}} m · Prepoznavanje pribl. {{recognition}} m',
      hFov: 'Horizontalni kut gledanja',
      vFov: 'Vertikalni kut gledanja',
      resolution: 'Razlučivost',
      lens: 'Objektiv',
      irRange: 'IR domet',
      ipClass: 'Klasa zaštite',
      audio: 'Zvuk',
      dayNight: 'Dan / noć',
      datenblatt: 'Tehnički list',
      planungswert: 'Planska vrijednost',
      doriNote:
        'Vidljivost/prepoznavanje/detalj: izračunate planske vrijednosti prema EN 62676-4 (gustoća piksela). Stvarna kvaliteta slike ovisi o modelu, objektivu, visini montaže, svjetlu i preprekama na mjestu.',
      groups: { standard: 'Standardno / unutarnji i vanjski', outdoor: 'Vanjski', panorama180: 'Panorama', ptz: 'Okretanje / zum' },
    },
    quickswitch: {
      title: 'Promijeni model kamere',
      subtitle: 'Izravno promijeni varijantu',
      active: 'Aktivno',
      recommended: 'Preporučeno',
      note: 'Orijentaciju, domet i visinu montaže postavite u desnom panelu svojstava.',
      close: 'Zatvori odabir modela',
    },
    elementTypes: {
      room: 'Prostorija / površina',
      polygon: 'Slobodna površina',
      wall: 'Zid',
      door: 'Vrata',
      window: 'Prozor',
      obstacle: 'Prepreka',
      watchzone: 'Cilj nadzora',
      privacy: 'Privatna zona / iznimka',
      camera: 'Kamera',
      text: 'Tekst',
    },
    defaults: { room: 'Prostorija', watchzone: 'Ciljno područje', text: 'Naziv prostorije' },
    defaultProject: 'Moj plan kamera',
    quickProject: 'Planiranje kamera (brza provjera)',
    options: {
      objectTypes: {
        Einfamilienhaus: 'Obiteljska kuća',
        Mehrfamilienhaus: 'Višestambena zgrada',
        Wohnung: 'Stan',
        'Ladengeschäft': 'Trgovina',
        'Büro oder Praxis': 'Ured ili ordinacija',
        Gastronomie: 'Ugostiteljstvo',
        'Lager oder Logistik': 'Skladište ili logistika',
        Werkstatt: 'Radionica',
        'Parkplatz oder Außenfläche': 'Parkiralište ili vanjska površina',
        Baustelle: 'Gradilište',
        Sonstiges: 'Ostalo',
      },
      areas: {
        Haupteingang: 'Glavni ulaz',
        Nebeneingang: 'Sporedni ulaz',
        Fenster: 'Prozor',
        Einfahrt: 'Prilaz',
        Garage: 'Garaža',
        'Garten oder Terrasse': 'Vrt ili terasa',
        Kasse: 'Blagajna',
        Verkaufsfläche: 'Prodajna površina',
        Lager: 'Skladište',
        Lieferzone: 'Dostavna zona',
        Parkplatz: 'Parkiralište',
        'Büro oder Innenraum': 'Ured ili unutarnji prostor',
        'Gesamte Außenfläche': 'Cijela vanjska površina',
        'Sonstiger Bereich': 'Drugo područje',
      },
      features: {
        'Live-Ansicht': 'Prikaz uživo',
        'lokale Aufzeichnung': 'Lokalno snimanje',
        'Smartphone-Zugriff': 'Pristup pametnim telefonom',
        'Wiedergabe gespeicherter Aufnahmen': 'Reprodukcija spremljenih snimki',
        Ereignisbenachrichtigungen: 'Obavijesti o događajima',
        'gute Sicht bei Dunkelheit': 'Dobra vidljivost u mraku',
        'Übersicht über eine große Fläche': 'Pregled velike površine',
        'Erkennung wichtiger Details': 'Prepoznavanje važnih detalja',
        'mehrere Benutzer': 'Više korisnika',
        'mehrere Standorte': 'Više lokacija',
        'vorhandene Anlage erweitern': 'Proširiti postojeći sustav',
        'SSG-Care-Betreuung': 'SSG Care briga',
      },
      recordingDurations: {
        'Bis 7 Tage': 'Do 7 dana',
        'Bis 14 Tage': 'Do 14 dana',
        'Bis 30 Tage': 'Do 30 dana',
        'Mehr als 30 Tage': 'Više od 30 dana',
        'noch unklar': 'još nejasno',
      },
      roomNames: {
        Eingang: 'Ulaz',
        Flur: 'Hodnik',
        Wohnzimmer: 'Dnevni boravak',
        'Büro': 'Ured',
        Verkaufsfläche: 'Prodajna površina',
        Kasse: 'Blagajna',
        Lager: 'Skladište',
        Werkstatt: 'Radionica',
        Parkplatz: 'Parkiralište',
        Außenbereich: 'Vanjski prostor',
      },
      obstacles: {
        saeule: 'Stup',
        regal: 'Polica',
        trennwand: 'Visoka pregrada',
        moebel: 'Blok namještaja',
        fahrzeug: 'Parkirno mjesto vozila',
        eigen: 'Imenovana prepreka',
      },
      watchKinds: {
        ueberblick: 'U potpunosti nadgledati područje',
        eingang: 'Promatrati ulaz',
        tuer: 'Nadzirati vrata',
        fenster: 'Nadzirati prozor',
        kasse: 'Zabilježiti blagajnu ili osjetljivu točku',
        zufahrt: 'Promatrati prilaz',
        kennzeichen: 'Provjeriti područje registarskih oznaka',
        flaeche: 'Pregled površine',
        details: 'Prepoznati važne detalje',
        individuell: 'Individualno područje',
      },
      watchPriorities: { normal: 'Normalno', wichtig: 'Važno', kritisch: 'Kritično' },
      watchGoals: { uebersicht: 'Pregled', beobachtung: 'Promatranje', detail: 'Detalj' },
      privacyKinds: {
        privat: 'Privatna zona',
        nachbar: 'Susjedno zemljište',
        oeffentlich: 'Javni nogostup ili ulica',
        mitarbeiter: 'Prostor za zaposlenike',
        ausgeschlossen: 'Područje koje se ne smije snimati',
      },
      categories: {
        standard: { label: 'Standardna kamera', hint: 'Svestrana za unutarnje i vanjske prostore' },
        wide: { label: 'Širokokutna kamera', hint: 'Širok pregled na kratkoj do srednjoj udaljenosti' },
        varifocal: { label: 'Kamera s promjenjivim kutom', hint: 'Kut gledanja postavlja se na mjestu' },
        panorama180: { label: 'Panoramska kamera 180°', hint: 'Vrlo široko snimanje, ograničeno prepoznavanje detalja' },
        fisheye360: { label: 'Kamera 360° / riblje oko', hint: 'Pogled na sve strane, slika se elektronički ispravlja' },
        ptz: { label: 'PTZ kamera', hint: 'Kamera za okretanje/naginjanje/zum za veće površine' },
        indoor: { label: 'Unutarnja kamera', hint: 'Optimizirana za unutarnje prostore' },
        outdoor: { label: 'Vanjska kamera', hint: 'Izvedba otporna na vremenske uvjete za vanjski prostor' },
      },
      dayNight: { tag: 'Dan', nacht: 'Noć', beides: 'Dan i noć' },
    },
    models: {
      'safire-turret-i1-4mp': { ai: 'Klasifikacija osoba i vozila (AI)', note: 'Svestrana turret kamera sa širokim kutom gledanja – dobar standard za unutra i van.' },
      'safire-turret-e1-4mp': { ai: 'Klasifikacija osoba i vozila (AI)', note: 'Povoljni početni model E1 serije s solidnom razlučivošću.' },
      'safire-turret-b1-4mp': { ai: '', note: 'Robusna economy turret kamera s kućištem otpornim na udarce (IK10).' },
      'safire-dome-i2-8mp': { ai: 'Klasifikacija osoba i vozila (AI)', note: 'Visoka 8 MP razlučivost – više detalja u istom kadru.' },
      'safire-bullet-4mp': { ai: 'Klasifikacija osoba i vozila (AI)', note: 'Klasični bullet oblik za vanjsku montažu. Kut gledanja kao planska vrijednost prema seriji.' },
      'safire-turret-nightcolor-4mp': { ai: 'Slika u boji u mraku (NightColor X)', note: 'Daje sliku u boji i pri slabom svjetlu – idealno za kritične noćne situacije. Kut gledanja kao planska vrijednost.' },
      'safire-turret-duallight-4mp': { ai: 'Klasifikacija osoba i vozila (AI)', note: 'DualLight s IR i bijelim LED (po 30 m) – fleksibilno noću. Kut gledanja kao planska vrijednost.' },
      'safire-panorama-180-8mp': { ai: 'Pregled od 180° sa zvučnikom i mikrofonom', note: 'Snima vrlo široko područje jednom kamerom – prepoznavanje detalja na daljinu je ograničeno.' },
      'safire-miniptz-4mp': { ai: 'Automatsko praćenje, klasifikacija osoba i vozila', note: 'PTZ kamera s automatskim praćenjem. Kut gledanja kao planska vrijednost (krajnji širokokutni položaj).' },
      'safire-ptz-15x-2mp': { ai: 'Automatsko praćenje, praćenje automobila i vozila', note: 'Velik domet zahvaljujući 15× zumu i 200 m IR. Kut gledanja kao planska vrijednost (krajnji širokokutni položaj).' },
    },
    disclaimer: {
      general:
        'Planer kamera daje neobvezujuće predplaniranje. Stvarni kadar i prikladan položaj kamere ovise, među ostalim, o modelu, objektivu, udaljenosti, visini montaže, svjetlosnim uvjetima, preprekama i uvjetima na mjestu.',
      result:
        'Ova procjena je neobvezujuće predplaniranje. Konačna preporuka daje se tek nakon provjere lokalnih uvjeta i odabira konkretne tehnike kamera.',
      upload: 'Tlocrti i fotografije objekta mogu sadržavati osjetljive informacije. Učitajte samo datoteke potrebne za obradu vašeg upita.',
      sichtfeld: 'Vrata i prozori mogu utjecati na linije vidljivosti. Materijal, ostakljenje, stanje otvaranja i refleksija svjetla moraju se provjeriti na mjestu.',
      datenschutz:
        'Za zahtjeve poput prepoznavanja lica, identifikacije osoba ili prepoznavanja registarskih oznaka potrebna je tehnička i pravna provjera zaštite podataka.',
    },
    hints: {
      '0':
        'Na temelju vaših podataka može odgovarati više položaja ili vrsta kamera. Za pouzdanu preporuku treba provjeriti kutove gledanja, visinu montaže, osvjetljenje i postojeće prepreke.',
      '1':
        'Širok kut gledanja ne znači automatski dovoljno prepoznavanje detalja. Udaljenost, razlučivost, kut, visina montaže i cilj nadzora utječu na stvarnu kvalitetu slike.',
      '2': 'Visina montaže i svjetlosni uvjeti moraju se provjeriti na mjestu.',
    },
    recommend: {
      noArea: 'Standardna preporuka dok još nije nacrtana površina. Nacrtajte svoju prostoriju i preporuka će se prilagoditi.',
      veryLarge: 'Vrlo velika površina (pribl. {{area}} m²) – PTZ sa zumom i velikim dometom za velike udaljenosti.',
      large: 'Velika površina (pribl. {{area}} m²) – robusni bullet oblik za vanjski prostor.',
      medium: 'Srednja do velika površina (pribl. {{area}} m²) – 8 MP za više detalja u širini.',
      compact: 'Kompaktna površina (pribl. {{area}} m²) – širok kut gledanja dobro pokriva prostoriju.',
    },
    analysisDynamic: {
      missingNoCameras: 'Još nema postavljenih kamera.',
      missingNoRooms: 'Još nisu nacrtane prostorije ili površine.',
      missingNoWalls: 'Nisu nacrtani zidovi – stošci vidljivosti nisu ograničeni.',
      missingNoZones: 'Nema označenih ciljeva nadzora.',
      missingNoPrivacy: 'Nema označenih privatnih ili isključenih zona.',
      missingNoInternet: 'Nedostaje informacija o internetskoj vezi.',
      missingNoPower: 'Nedostaje informacija o napajanju strujom.',
      hintUncovered: 'Ciljna područja bez dovoljne pokrivenosti: provjerite položaje ili planirajte dodatne kamere.',
      hintPartial: 'Neka ciljna područja pokrivena su samo djelomično – prilagodite kut, položaj ili domet.',
      hintDetailRange: 'Domet detalja od „{{name}}“ (pribl. {{range}} m) vjerojatno nije dovoljan sam za velike prostorije – dodatna kamera mogla bi biti korisna.',
      hintPrivacy: 'Vidno polje preklapa se s označenom privatnom zonom. Treba provjeriti položaj, orijentaciju ili tehničko maskiranje.',
      hintMount: 'Visina montaže i svjetlosni uvjeti moraju se provjeriti na mjestu.',
      hintKennzeichen: 'Potrebna tehnička i pravna provjera zaštite podataka.',
      noteDetailRange:
        'Prepoznavanje detalja vjerojatno nije dovoljno za pribl. {{distance}} m udaljenosti – detalj maks. pribl. {{identification}} m. Treba provjeriti uži kut ili model s većom razlučivošću.',
      noteDetailUncertain: 'Prepoznavanje detalja na većim udaljenostima je neizvjesno – treba provjeriti uži kut i visinu montaže.',
      notePartial: 'Ovo područje možda je pokriveno samo djelomično.',
      suggestNear: 'Cilj nadzora „{{target}}“ nalazi se blizu „{{privacy}}“. Položaj i orijentacija moraju se pažljivo odabrati – potrebna je pravna provjera zaštite podataka.',
      suggestHeuristic: 'Prijedlozi su heuristički. Svaka kamera može se slobodno pomicati, rotirati, mijenjati ili brisati.',
      suggestWide: 'Širok kut gledanja ne znači dovoljno prepoznavanje detalja. Udaljenost, razlučivost i visina montaže utječu na kvalitetu slike.',
      cameraNoteDetail: 'Prvi mogući položaj kamere – za ciljeve s detaljima planirajte uži kut.',
      cameraNoteCheck: 'Prvi mogući položaj kamere – molimo provjerite i prilagodite.',
      cameraSuggestion: 'Prijedlog {{count}}',
      uncoveredPartial: 'djelomično',
      uncoveredInsufficient: 'nedovoljno',
      toastNoPositions: 'Nisu pronađeni novi položaji. Dodajte ciljeve nadzora ili prostorije.',
      toastSuggested: 'Predloženo je {{count}} prvih mogućih položaja kamere.',
    },
  },
};